import React, {Component, lazy, Suspense} from 'react';
import Modal from 'react-bootstrap/Modal';
import Study from "../../../core/api/study/Study";
import ListHeader from "../list-header/ListHeader";
import {connect} from "react-redux";
import {updateDownloadCount} from "../../../actions/PanelHeader";
import Storage from "../../../helpers/Storage";
import eventBus from '../../../core/utils/EventBus';
import { _alert } from '../../../actions/Alert';
import './list.scss';
import colors from '../../../assets/scss/variable/color.scss';
import T from '../../../shared/component/t/T';
import MessageBar from '../../../shared/component/MessageBar/MessageBar';
import Label from '../../../shared/component/Label/Label';
import ComboBox from '../../../shared/component/ComboBox/ComboBox2';
import { _loading } from '../../../actions/Loading';
import snippets from "../../../helpers/snippets";
import {default as _} from "../../../helpers/Translate";
import config from "../../../config";
import {handleScrollingDown, handleScrollingUp} from "../../../actions/PanelScrolling";
import {ConfigProvider, Skeleton, theme} from "antd"
import SeparatorItem from "../list-row/SeparatorItem";
const ListRow = lazy(() => import('../list-row/ListRow'));

const study = new Study();

class List extends Component {

    constructor(props) {
        super(props);
        this.handleShowModal = this.handleShowModal.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.getStudyListData = this.getStudyListData.bind(this);
        this.setSearchData = this.setSearchData.bind(this);
        this.handleCheckBoxDate = this.handleCheckBoxDate.bind(this);
        this.onPageEvent = this.onPageEvent.bind(this);

        //Refs
        this.scrollContainerRef = React.createRef();

        // Values
        this.timeout = 0;
        this.timeScrolling = 0;
        this.lastScrollValue = 0;

        this.state = {
            device: this.props.device,
            prevScrollPos: window.scrollY,
            scroll: "up",
            ignored: false,
            showSearchesAsHeader: false,
            studyHeaderFilters: Storage.studyHeaderFiltersGet(),
            modalSettings: false,
            modalProfile: false,
            modalDownload: false,
            modalPattern: false,
            modalManagePattern: false,
            studyList: [],
            dropdown_datepicker: false,
            dropdown_states: false,
            dropdown_devices: false,
            selectedCheckboxes: [],
            initialDateBefore: config.daysBeforePanel,
            searchAttr: {
                start: 0,
                datepickerFrom: config.daysBeforePanel,
                datepickerTo: null,
                limit: parseInt(Storage.getPageSize()),
                myReports: undefined,
                like: undefined,
            },
            hidePager: false,
            lang: Storage.getLanguage(),
            calendar: Storage.getCalendar(),
            rowCount: 0,
            totalCount: 0,
            selectAll: false,
            pageSize: 0,
            lazyLoadFinished: false,
            bottomMessages: null,
            topMessages: null,
            pagerValues: [
                {
                    id: 0,
                    value: 0,
                    rawText: `(${parseInt(Storage.getPageSize())}) `,
                    text: "auto"
                },
                {
                    id: 1,
                    value: 10,
                    rawText: 10,
                    text: "quantity"
                },
                {
                    id: 2,
                    value: 20,
                    rawText: 20,
                    text: "quantity",
                },
                {
                    id: 3,
                    value: 50,
                    rawText: 50,
                    text: "quantity"
                },
                {
                    id: 4,
                    value: 100,
                    rawText: 100,
                    text: "quantity"
                },
                {
                    id: 5,
                    value: 200,
                    rawText: 200,
                    text: "quantity"
                },
                {
                    id: 6,
                    value: 500,
                    rawText: 500,
                    text: "quantity"
                }
            ],
            paginator: [1],
            currentPage: 1,
            lastPage: 1,
            disableGoAction: false,
        };
    }

    componentDidMount() {
        let size = this.detectPageSize()
        this.setState({
            pagerValues: this.state.pagerValues.map(item => {
                if (item.id === 0) {
                    return {
                        ...item,
                        rawText: size
                    };
                }
                return item;
            }),
            pageSize: size
        }, () => {
            Storage.setPageSize(size);
            this.setFilters({
                limit: size
            });
        });
        eventBus.on("filterByDate", data => this.setFilters(data));
        eventBus.on("filterByLikeOrMy", data => this.filterByLikeOrMy(data));
        eventBus.on("sessionRevoked", () => this.setFilters({limit: this.detectPageSize(false)}));
        eventBus.on("reloadData", () => this.setFilters({}, true));
        if (this.scrollContainerRef.current){
            this.scrollContainerRef.current.addEventListener('scroll', this.handleScroll);
        }
    }

    componentWillUnmount() {
        eventBus.remove("filterByDate", () => {});
        eventBus.remove("filterByLikeOrMy", () => {});
        eventBus.remove("sessionRevoked", () => {});
        eventBus.remove("reloadData", () => {});
        if (this.scrollContainerRef.current) {
            this.scrollContainerRef.current.removeEventListener('scroll', this.handleScroll);
        }
        if (this.timeScrolling) {
            clearTimeout(this.timeScrolling);
        }
    }

    filterByLikeOrMy = (data) => {
        let someProperty = {...this.state.searchAttr, ...data}
        this.setState({searchAttr: someProperty}, ()=>{
            this.setFilters(data)
        })
    }

    handleScroll = () => {
        const { prevScrollPos } = this.state;
        const currentScrollPos = this.scrollContainerRef.current.scrollTop;
        const scrollingUp = prevScrollPos > currentScrollPos;
        const scrollDiff = Math.abs(prevScrollPos - currentScrollPos) > 10;
        const bottomThreshold = 50; // You can adjust this threshold as needed
        const isNearBottom = this.scrollContainerRef.current.scrollHeight - this.scrollContainerRef.current.scrollTop
            <= this.scrollContainerRef.current.clientHeight + bottomThreshold;
        const isNearTop = this.scrollContainerRef.current.scrollTop <= 50;
        const containerHeightChanged = this.scrollContainerRef.current.clientHeight !== this.state.containerHeight
        this.state. containerHeight = this.scrollContainerRef.current.clientHeight;
        this.state.prevScrollPos = currentScrollPos;

        if (containerHeightChanged){
            this.state.ignored = true
            if (this.timeScrolling) {
                clearTimeout(this.timeScrolling);
            }
            this.timeScrolling = setTimeout(() => {
                this.state.ignored = false
            }, 300);
        } else if (isNearTop) {
            this.scrollUP()
        } else if (!this.state.ignored){
            if ((scrollDiff && scrollingUp && !isNearBottom) ) {
                this.scrollUP()
            } else if(scrollDiff && !scrollingUp && !isNearTop) {
                this.scrollDOWN()
            }
        }
    }

    scrollUP = () => {
        this.state.scroll= "up"
        this.props.dispatch(handleScrollingUp())
    }

    scrollDOWN = () => {
        this.state.scroll= "down" ;
        this.props.dispatch(handleScrollingDown())
    }

    handleShowSearchesAsHeader =()=>{
        return this.state.scroll === "down" && this.state.device !== "desktop";
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.calendar !== this.props.calendar) {
            this.genericUpdateHandler("calendar", this.props.calendar);
        }
        if (prevProps.language !== this.props.language) {
            this.genericUpdateHandler("lang", this.props.language);
        }
        if (prevProps.device !== this.props.device) {
            this.setState({device: this.props.device})
        }
        if (prevProps.downloadCount !== this.props.downloadCount) {
            this.setState({selectedCheckboxes: this.props.downloadCount?.downloadCount}, ()=>{})
        }
        if (prevState.studyList !== this.state.studyList) {
            Storage.PatientsListSave(this.state.studyList)
        }
        if (prevState.scroll !== this.props.scroll) {
            this.setState({scroll: this.props.scroll})
        }
        if (prevState.studyHeaderFilters !== this.state.studyHeaderFilters) {
            this.setState({studyHeaderFilters: this.state.studyHeaderFilters})
        }
    }

    addScrollListener = () => {
        if (this.state.pageSize < 1) {
            const dataGrid = document.querySelector(".list__helper__container");
            this.lastScrollValue = dataGrid.scrollTop;
    
            dataGrid.addEventListener("scroll", this.scrollDetector);
        }
    }

    removeScrollListener = () => {
        const dataGrid = document.querySelector(".list__helper__container");
        dataGrid.removeEventListener("scroll", () => {});
    }

    scrollDetector = (e) => {
        if (e.target.scrollTop > this.lastScrollValue) {
            const detector = document.getElementById("scroll__detector");
            const box = detector.getBoundingClientRect();

            if (box.top < window.innerHeight && box.bottom >= 0) {
                this.getMoreData();
            }
        }
        this.lastScrollValue = e.target.scrollTop;
    }

    detectPageSize = (checkPageSize = true) => {
        if (this.state.pageSize > 1 && checkPageSize)
            return parseInt(this.state.pageSize);
        let dataRowHeight = window.innerWidth < 1333 ? 66 : 55;
        let dataGrid = document.querySelector(".panel__content");
        let tableHeader = document.querySelector(".thead");
        let pageSize = Math.max(Math.round(((dataGrid.offsetHeight - tableHeader?.offsetHeight - 46) / dataRowHeight) + 1), 1);
        return pageSize;
    }

    setFilters = (data = {}, resetFilters = false, fromPaginator = false) => {
        let dataToSend;

        if (resetFilters) {
            dataToSend = {
                start: 0,
                datepickerFrom: config.daysBeforePanel,
                datepickerTo: null,
                limit: this.detectPageSize()
            };
        }
        else {
            if (Object.keys(data).length) {
                dataToSend = {...this.state.searchAttr, ...data};
                if (this.state.searchAttr?.like) {
                    dataToSend = {...dataToSend, like: true};
                } if (this.state.searchAttr?.myReports) {
                    dataToSend = {...dataToSend, myReports: true};
                }
            } else {
                dataToSend = {...this.state.searchAttr};
            }
        }

        if (!fromPaginator) {
            dataToSend.start = 0;
            this.state.paginator = [1];
        }
        this.setSearchData({...dataToSend});
    }

    genericUpdateHandler = (key, value, callBack = () => {}) => {
        this.setState({
            [key]: value
        }, callBack);
    }

    handleUpdateLanguage(thisProps) {
        this.setState({
            lang: thisProps.language,
        });
    }

    handleClose(modal) {
        this.setState({
            [modal]: false
        });
    }

    handleShowModal(modal) {
        this.setState({
            [modal]: true
        });
    }

    handleShowDropdown(dropdown) {
        this.setState({
            [dropdown]: !this.state[dropdown]
        });
    }

    getMoreData = () => {
        if (!this.state.lazyLoadFinished) {
            let startValue = this.state.searchAttr.start + this.state.searchAttr.limit;
    
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
    
            this.timeout = setTimeout(() => {
                this.setState({
                    searchAttr: {...this.state.searchAttr, start: startValue},
                }, () => {
                    this.getStudyListDataLazyLoad(this.state.searchAttr);
                });
            }, 1000);
        }
    }

    getStudyListDataLazyLoad = (data = null) => {
        data = {...data, grouping: this.state.device === "desktop"}
        study.getData(data).then((response) => {
            this.setState({
                studyList: [ ...this.state.studyList, ...response.data.studies],
                rowCount: response.data.studies.length + this.state.studyList.length,
                lazyLoadFinished: response.data.studies.length < this.state.searchAttr.limit
            });
        });
    }

    setPaginator = (fetchedRecordsCount, newCurrentPage) => {
        let paginator = [...this.state.paginator];

        if (newCurrentPage > this.state.currentPage || paginator.length <= 1) {
            let newPage = this.state.paginator[this.state.paginator.length - 1] + 1;

            
            if (fetchedRecordsCount >= this.state.searchAttr.limit) {
                let exist = paginator.find(item => item === newCurrentPage);
                let lastIndex = this.state.paginator[this.state.paginator.length - 1];
                
                if (!exist || newCurrentPage === lastIndex)
                    paginator = [...this.state.paginator, newPage];
            }
        }

        if (newCurrentPage === 1 && fetchedRecordsCount < this.state.searchAttr.limit) {
            paginator = [1];
        }

        return paginator;
    }

    getStudyListData(data = null) {
        data = {...data, grouping: this.state.device === "desktop"}
        study.getData(data).then((response) => {
            let newCurrentPage = Math.round(this.state.searchAttr.start / this.state.searchAttr.limit + 1);
            let nextButtonDisable = response.data.studies.length < this.state.searchAttr.limit;

            this.setState({
                studyList: response.data.studies,
                rowCount: response.data.studies.length,
                totalCount: response.data?.total_count,
                bottomMessages: snippets.isObjectEmpty(response.data?.bottom_message.message) ? null : response.data?.bottom_message,
                topMessages: snippets.isObjectEmpty(response.data?.top_message.message) ? null : response.data?.top_message ,
                currentPage: newCurrentPage,
                lastPage: this.state.currentPage,
                disableGoAction: nextButtonDisable,
                paginator: this.setPaginator(response.data.studies.length, newCurrentPage),
            }, () => {
                if (this.state.topMessages !== null) {
                    this.props.dispatch(_alert(true, this.state.topMessages.type, this.state.topMessages.message, true, true, ));
                } else {
					this.props.dispatch(_alert(false, "success", '' ));
                }
                document.getElementById('list__helper__container').scroll(-Infinity, -Infinity)
                this.props.dispatch(_loading(false));
            });
        }).catch(error => {
            if (error.code === "ERR_NETWORK") {
                this.props.dispatch(_alert(true, 'error', <T token={"network_error"} />));
            }
            this.props.dispatch(_loading(false));
        }).finally(() => {});
    }

    setSearchData(data) {
        if (this.timeout) {
            clearTimeout(this.timeout);
        }

        this.timeout = setTimeout(() => {
            this.props.dispatch(_loading(true));
            this.setState({
                searchAttr: {...data}
            }, () => {
                let finalData = {...this.state.searchAttr};

                Storage.lastFiltersSave(finalData)
                this.getStudyListData(finalData);
            });
        }, 500);
    }

    onPageEvent(start) {
        let tempStart = parseInt(start) + this.detectPageSize();

        this.setFilters({
            start: tempStart
        });
    }

    loadNextChunk = (pageNumber = null) => {
        if (!pageNumber) {
            throw new Error("List.jsx>loadNextChunk method pageNumber parameter is null.");
        }
        pageNumber = parseInt(pageNumber);

        if (pageNumber === this.state.currentPage) {
            return;
        }

        const pageSize = this.detectPageSize();
        let finalStartValue = pageNumber * pageSize - pageSize;

        this.setFilters({start: finalStartValue}, false, true);
    }

    handleCheckBoxDate(data) {
        let selectedArr = [...this.state.selectedCheckboxes];
        const _index = selectedArr.findIndex(x => x.study.id === data.study.id);
        if (_index !== -1)
            selectedArr.splice(_index, 1);
        else
            selectedArr.push(data);

        this.props.dispatch(updateDownloadCount(selectedArr));
    }

    selectAllRecords = (value) => {
        let tempData = [];

        if (value) {
            tempData = this.state.studyList.map(item => ({
                study: item[0],
                patient: item[1],
                report: item[2]
            }));
        }

        this.props.dispatch(updateDownloadCount(tempData));
        this.setState({
            selectedCheckboxes: [...tempData],
            selectAll: value,
        });
    }

    resetAllFilters = () => {
        eventBus.dispatchEvent("resetAllFilters");
        this.setFilters(null, true)
    }

    handlePageSizeChange = (value) => {
        let tempValue = parseInt(value);

        this.setState({
            pageSize: tempValue,
            searchAttr: {
                ...this.state.searchAttr,
                limit: tempValue < 1 ? this.detectPageSize(false) : tempValue,
                start: 0
            }
        }, () => {
            this.setFilters();
            Storage.setPageSize(tempValue);
        });
    }

    studyHeaderFiltersChanges = (e) => {
        this.setState({studyHeaderFilters: {...e}}, ()=>{
            Storage.studyHeaderFiltersActiveChange(e)
        })
    }

    excelClick = () => {
        study.getData({...this.state.searchAttr, response_type: "excel"}).then(response => {
            const blob = new Blob([response.data], {type: response.headers['content-type']})
            const link = document.createElement('a');
            const date = new Date().toLocaleString("fa", {timeZone: "Asia/Tehran",  hour12: false}).replaceAll("/", "-").replaceAll(":", "-").replace(", ","__")
            const url = window.URL.createObjectURL(blob);
            link.href = url
            link.setAttribute('download', `${_.localNumber(date, "en")}.xls`);
            document.body.appendChild(link);
            link.click();
            // Clean up
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        })
        .catch(error => console.error('Error fetching Excel data:', error));
    }

    lazyListRow = (item, index) => {
        let selected = this.state.selectAll || this.state.selectedCheckboxes?.some(it => it?.study?.id === item[0]?.id)

        return (
            <Suspense key={index} fallback={this.loadingComponent()}>
                <ListRow key={item[0].id || index} data={item} setCheckBoxDate={this.handleCheckBoxDate} selectCheckBox={selected}
                         calendarType={this.state.calendar} studyHeaderFilters={this.state.studyHeaderFilters}/>
            </Suspense>
        )
    }

    loadingComponent = () => {
        return <>
            <SeparatorItem cols={14}/>
            <tr> <td colSpan={14}>
                {this.state.device === "desktop" && <ConfigProvider theme={{algorithm: theme.darkAlgorithm}} >
                    <Skeleton.Input style={{ width: '85vw', height: '65px' }} active/>
                </ConfigProvider>}
            </td> </tr>
        </>
    }

    render() {
        const directionClass = this.state.lang === "fa" ? "rtl": "ltr";
        const rightOrLeft = this.state.lang === "fa" ? "right" : "left";
        const opposite = this.state.lang === "fa" ? "left" : "right";

        let from = this.state.studyList.length === 0 ? 0 :(this.state.currentPage - 1) * this.detectPageSize() +1;
        let to = this.state.studyList.length === 0 ? 0 : (this.state.currentPage-1) * this.detectPageSize() + this.state.studyList.length;
        let final = this.state.studyList.length === 0 ? `${0}`:`${from} - ${to}`

        return (
            <>
            <div className={'list'}>
                {/* New table using div */}
                <div className="list__helper__container" id="list__helper__container" ref={this.scrollContainerRef}>
                    <table className="list__data-table" dir={directionClass}>
                        <ListHeader handleData={this.setFilters}
                                    checkAllState={this.state.selectAll}
                                    handleCheckAll={this.selectAllRecords}
                                    resetFilters={this.resetAllFilters}
                                    initialDatesBefore={this.state.searchAttr.datepickerFrom}
                                    studyHeaderFilters={this.state.studyHeaderFilters}
                                    studyHeaderFiltersChanges={this.studyHeaderFiltersChanges}
                        />
                        <tbody className={"list__data-table-body"}>
                            {
                                this.state.studyList.map((item, index) => {
                                    return this.lazyListRow(item, index)
                                })
                            }
                        </tbody>
                    </table>
                </div>
                {
                    (this.state.bottomMessages) &&
                    <MessageBar messageText={this.state.bottomMessages.message} showOrHide={this.handleShowSearchesAsHeader()} />
                }
                <div className={`list__pager ${this.handleShowSearchesAsHeader() ? "hidden": "show" }`}>
                    <div className={`pager`}>
                        <div className="pager__container">
                            <div className={"results"} >
                                <Label className={"result"}
                                       labelText="results"
                                       labelRawText={`${_.init3(final)} ${this.state.totalCount ? `${_.init("from")} ${_.init3(this.state.totalCount)}` : ""}`} />
                                {this.state.device === "desktop" &&
                                    <Label className={"download__excel"}
                                           icon={"fal fa-file-excel"}
                                           labelText="download_excel"
                                           color={colors.excel}
                                           removeColon={true}
                                           onClick={this.excelClick}/>
                                }
                            </div>
                            <div className={`actions__container`} style={{justifyContent: "center"}}>
                                <div className={'pager__action ' + (this.state.searchAttr.start === 0 && ' pager__action--disable')}
                                    onClick={() => this.loadNextChunk(this.state.currentPage - 1)}>
                                    <i className={`fa fa-light fa-arrow-${rightOrLeft}`}/>
                                </div>
                                {
                                    this.state.paginator.map((item) => <div key={item} className={`pager__action ${item === this.state.currentPage ? "active" : ""}`} onClick={() => this.loadNextChunk(item)}>
                                        { _.init3(item) }
                                    </div>)
                                }
                                <div className={'pager__action ' + (this.state.disableGoAction && 'pager__action--disable')}
                                    onClick={() => this.loadNextChunk(this.state.currentPage + 1)}>
                                    <i className={`fa fa-light fa-arrow-${opposite}`}/>
                                </div>
                            </div>
                            <div className="records__counter">
                                <ComboBox type="select"
                                          labelText={this.state.device !== "desktop" ? "" : "show"}
                                          selectedItem={this.state.pageSize}
                                          comboboxValues={this.state.pagerValues}
                                          changeValueHandler={this.handlePageSizeChange} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                {/*<div onClick={() => this.handleShowModal('modalPattern')}>Launch pattern</div>*/}
                {/*<div onClick={() => this.handleShowModal('modalManagePattern')}>Launch pattern</div>*/}

                <Modal show={this.state.modalPattern} size="lg" onHide={() => this.handleClose('modalPattern')}>
                    <div className={'imodal imodal--pattern'}>

                        <div className={'imodal__header'}>
                            <div className={'imodal__close'} onClick={() => this.handleClose('modalDownload')}>
                                <i className={'fa fa-light fa-times-circle'}/></div>
                            <div className={'imodal__title'}>الگو شماره ۲</div>
                            <div className={'imodal__header-action'}>
                                <i className={'fa fa-light fa-pen-to-square'}/>
                                <i className={'fa fa-light fa-trash-can action--red'}/>
                            </div>
                        </div>

                        <div className={'imodal__body'}>
                            <div className={'pattern__section pattern__section--header'}>
                                <div className={'section__title'}>عنوان</div>
                                <div className={'section__content'}>
                                    نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی
                                </div>

                                <div className={'section__content'}>
                                    <input type="text"
                                           value={'نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی'}/>
                                    <div className={'content__subtitle'}>برای الگو عنوان مناسبی بنویسید، مثل: موارد 7
                                        روز گذشته تایپ شده برای CT
                                    </div>
                                </div>
                            </div>

                            <div className={'pattern__section pattern__section--detail'}>
                                <div className={'section__title'}>الگو شما</div>
                                <div className={'section__content'}>
                                    <div className={'content__item'}>
                                        <div className={'item__key'}>تاریخ مراجعه</div>
                                        <div className={'item__value'}>امروز</div>
                                    </div>
                                    <div className={'content__item'}>
                                        <div className={'item__key'}>جنسیت</div>
                                        <div className={'item__value'}>مرد</div>
                                    </div>

                                    <div className={'content__item'}>
                                        <div className={'item__key'}>گزارش</div>
                                        <div className={'item__value'}>
                                            <span className={'value__item value__item--d'}>D</span>
                                            <span className={'value__item value__item--s'}>S</span>
                                            <span className={'value__item value__item--his'}>HIS</span>
                                        </div>
                                    </div>

                                    <div className={'content__item'}>
                                        <div className={'item__key'}>دستگاه</div>
                                        <div className={'item__value'}>
                                            <span className={'value__item value__item--bordered'}>CTO</span>
                                            <span className={'value__item value__item--bordered'}>OT</span>
                                            <span className={'value__item value__item--bordered'}>MRI</span>
                                        </div>
                                    </div>

                                    <div className={'content__item'}>
                                        <div className={'item__key'}>وضعیت</div>
                                        <div className={'item__value'}>بستری - اورژانسی</div>
                                    </div>

                                    <div className={'content__item'}>
                                        <div className={'item__key'}>پزشک</div>
                                        <div className={'item__value'}>دکتر احورایی حسینی</div>
                                    </div>


                                </div>
                            </div>

                        </div>
                        <div className={'imodal__action'}>
                            <div className={'imodal__btn imodal__btn--primary'}>اعمال الگو</div>
                            <div className={'imodal__btn imodal__btn--secondary'}>لغو</div>
                        </div>
                    </div>
                </Modal>

                <Modal show={this.state.modalManagePattern} size="lg"
                       onHide={() => this.handleClose('modalManagePattern')}>
                    <div className={'imodal imodal--managePattern'}>

                        <div className={'imodal__header'}>
                            <div className={'imodal__close'} onClick={() => this.handleClose('modalDownload')}>
                                <i className={'fa fa-light fa-times-circle'}/></div>
                            <div className={'imodal__title'}>مدیریت الگوها</div>
                            <div className={'imodal__header-action'}></div>
                        </div>

                        <div className={'imodal__body'}>
                            <div className={'managePattern__section managePattern__section--header'}>
                                <div className={'section__title'}>الگوهای شما</div>
                                <div className={'section__content'}>
                                    <table className={'pattern-list'}>
                                        <thead>
                                        <tr>
                                            <td>شماره</td>
                                            <td>عنوان</td>
                                            <td></td>
                                            <td></td>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr>
                                            <td className={'list__col list__col--number'}>1</td>
                                            <td>نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی ...</td>
                                            <td>
                                                <i className={'fa fa-light fa-pen-to-square'}/>
                                                <i className={'fa fa-light fa-trash-can list__col--red'}/>
                                            </td>
                                            <td className={'list__col list__col--primary'}>اعمال الگو</td>
                                        </tr>
                                        <tr>
                                            <td className={'list__col list__col--number'}>1</td>
                                            <td>نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی ...</td>
                                            <td>
                                                <i className={'fa fa-light fa-pen-to-square'}/>
                                                <i className={'fa fa-light fa-trash-can list__col--red'}/>
                                            </td>
                                            <td className={'list__col list__col--primary'}>اعمال الگو</td>
                                        </tr>
                                        <tr>
                                            <td className={'list__col list__col--number'}>1</td>
                                            <td>نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی ...</td>
                                            <td>
                                                <i className={'fa fa-light fa-pen-to-square'}/>
                                                <i className={'fa fa-light fa-trash-can list__col--red'}/>
                                            </td>
                                            <td className={'list__col list__col--primary'}>اعمال الگو</td>
                                        </tr>
                                        <tr>
                                            <td className={'list__col list__col--number'}>1</td>
                                            <td>نتایج تایپ شده امروز دستگاه های CT - MRI برای دکتر یعقوبی ...</td>
                                            <td>
                                                <i className={'fa fa-light fa-pen-to-square'}/>
                                                <i className={'fa fa-light fa-trash-can list__col--red'}/>
                                            </td>
                                            <td className={'list__col list__col--primary'}>اعمال الگو</td>
                                        </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>

                        </div>
                        <div className={'imodal__action'}>
                            {/*<div className={'imodal__btn imodal__btn--primary'}>اعمال الگو</div>*/}
                            {/*<div className={'imodal__btn imodal__btn--secondary'}>لغو</div>*/}
                        </div>
                    </div>
                </Modal>
            </>
        );
    }
}


const mapStateToProps = state => {
    const language = state.LangReducer.language;
    const calendar = state.CalendarReducer.type;
    const device = state.DeviceModeReducer.mode
    const scroll = state.panelScrollingReducer.scroll_direction
    const downloadCount = state.panelHeaderReducer;

    return {language, calendar, device, scroll, downloadCount};
};

export default connect(mapStateToProps)(List);